import { Stack, Typography } from "@mui/material";
import type { Theme } from "@mui/material/styles";

export const TotalValue = ({
	value,
	theme,
}: {
	value: string;
	theme: Theme;
}) => (
	<Stack mt={0.5}>
		<Typography
			variant="deprecatedBody1"
			color={theme.palette.deprecated.grey[700]}
		>
			{value}
		</Typography>
	</Stack>
);
